import Footer from "../../components/Footer";
import Header from "../../components/Header";
import CTA from "./CTA";
import Features from "./Features";
import Hero from "./Hero";
import { ToastContainer } from "react-toastify";

function Home() {
    return (
        <div className="min-h-screen">
            <ToastContainer />
            <Header />
            <Hero />
            <Features />
            <CTA />
            <Footer />
        </div>
    );
}

export default Home;